import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Schedule } from '@/features/accounts/types';
import { type ScheduleControls } from '@/features/accounts/schedule/hooks/useScheduleControls';
import CollapseChevron from './CollapseChevron';
import ScheduleCard from './ScheduleCard';
import ScheduleListEmptyState from './ScheduleListEmptyState';

interface Props {
  workable: Schedule[];
  rest: Schedule[];
  actions: ScheduleControls;
}

export default function ScheduleList({ workable, rest, actions }: Props) {
  const [revealed, setRevealed] = useState(false);

  if (workable.length === 0 && rest.length === 0) {
    return <ScheduleListEmptyState />;
  }

  return (
    <>
      {workable.map((schedule) => (
        <ScheduleCard key={schedule.id} schedule={schedule} actions={actions} />
      ))}

      {rest.length > 0 && (
        <>
          <button
            type="button"
            onClick={() => setRevealed((shown) => !shown)}
            aria-expanded={revealed}
            className="flex w-full items-center gap-1.5 border-t-2 border-slate-200 px-5 py-3 text-left text-sm font-medium text-slate-500 transition hover:bg-slate-100/60 hover:text-slate-700"
          >
            <CollapseChevron collapsed={!revealed} />
            <FormattedMessage
              id={revealed ? 'schedule.list.hideRest' : 'schedule.list.showRest'}
              values={{ count: rest.length }}
            />
          </button>

          {revealed &&
            rest.map((schedule) => (
              <ScheduleCard key={schedule.id} schedule={schedule} actions={actions} />
            ))}
        </>
      )}
    </>
  );
}
